<template>
    <el-container>
        <el-main>
            <div style="max-width:800px;margin:0 auto">
                <div class="container">
                    <el-header> 
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 测评</el-breadcrumb-item>
                            <el-breadcrumb-item>DISC性格测评</el-breadcrumb-item>
                        </el-breadcrumb>
                    </el-header>
                    <el-header>
                        <h2 id="typography-zi-ti">DISC性格测评</h2>
                        <el-progress :percentage="percentage" :format="percentageFormat"></el-progress>
                    </el-header>
                    <el-main>

                    </el-main>
                </div>

                <div class="container" v-if="options.length>0">
                    <el-header> 
                        <el-row>
                            {{xuhao}}. 请选择一个最符合你自己的选项和最不符合自己的选项
                        </el-row>
                    </el-header>
                    <div id="question" class="question">
                        <el-row v-for="(item,i) in options" :key="i">
                            <el-button ref="aa" :class="btnStyle[i]" plain @click="checkedData(i,item.id,item.m_type,item.l_type)">{{item.content}}</el-button>
                            <template v-if="(xuhao-1 < result.length && (result[xuhao-1]['m_id']-1)%4 == i) || (checkbox.length != 0 && checkbox[0] == i)">
                                <sup class="el-badge__content el-badge__content--primary is-fixed">最符合</sup>
                            </template>
                            <template v-if="(xuhao-1 < result.length && (result[xuhao-1]['l_id']-1)%4 == i) || (checkbox.length == 2 && checkbox[1] == i)">
                                <sup class="el-badge__content el-badge__content--undefined is-fixed">最不符合</sup>
                            </template>
                        </el-row>
                    </div>
                    <el-row size="large" style="margin-top:30px">
                        <el-button type="" @click="prevOption" icon="el-icon-back" :disabled="((xuhao>1 && checkbox.length == 0) || (checkbox.length == 2 && xuhao == 24)) ? false : true">上一题</el-button>
                        <el-button type="" @click="nextOption" icon="el-icon-right" :disabled="(xuhao-1 < result.length && checkbox.length == 0 && xuhao<24) ? false : true">下一题</el-button>
                        <el-button type="" @click="onSubmit" v-if="result.length == 24 && checkbox.length != 1 && checkbox[0] != -1">提交</el-button>
                    </el-row>
                </div>
            </div>



            <!-- pdf生成区域 -->
            <div id="pdfDom" style="width:1200px;display:none;">
                <div class="page-div">
                    <img :src="titleImg" style="margin:70px 70px;width:280px;float:left">
                    <div style="margin-top:42%;margin-bottom:70px">
                        <div style="height:35px;background-color:#3b8ad9"></div>
                        <div style="height:300px;background-color:#71a5d5">
                            <!-- <img :src="titleImg" style="margin-bottom:5%;width:300px;float:left;margin-left:190px;margin-top:30px"> -->
                            <div style="padding-top: 70px;font-size: 64px;font-weight: 400;color: #fff;font-family: 'Microsoft YaHei';">
                                DISC性格测评
                            </div>
                            <div style="font-size: 40px;font-weight: 400;color: #fff;font-family: 'Microsoft YaHei';">
                                Disc personality test
                            </div>
                        </div>
                        <div style="height:35px;background-color:#3b8ad9;margin-top:20px"></div>
                    </div>
                    <!-- <img :src="titleImg2" style="margin-top:30%;margin-bottom:5%;width:100%;"> -->
                    <el-row class="text-left" style="margin-bottom:10px">
                        <el-col :span="3" :offset="8">
                            <span>姓名：</span>
                        </el-col>
                        <el-col :span="11">
                            <span>{{username}}</span>
                        </el-col>
                    </el-row>
                    <el-row class="text-left">
                        <el-col :span="3" :offset="8">
                            <span>完成时间：</span>
                        </el-col>
                        <el-col :span="11">
                            <span>{{backdata.create_time}}</span>
                        </el-col>
                    </el-row>
                    <img :src="qrcodeImg" style="margin-top:50px;margin-bottom:10px;width:150px">
                    <el-row style="margin-bottom:100px">
                        <span>扫描二维码，关注「海蓝背调」</span>
                    </el-row>
                    <el-row style="margin-bottom:40px">
                        <span>本报告内容涉及个人隐私，请注意保密</span>
                    </el-row>
                    <el-row>
                        <span>海蓝背调 ● 版权所有</span>
                    </el-row>
                </div>
                <div class="page-div">
                    <img :src="titleImg" class="head-row">
                    <el-row>
                        <el-col :span="4" :offset="1">
                            <span style="font-size:36px;font-family: 'Microsoft YaHei';">前言</span>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top:50px">
                        <el-col :span="8" :offset="2">
                            <img :src="prefaceImg" style="width:100%">
                        </el-col>
                        <el-col :span="11" :offset="1" class="text-left">
                            <p>行为方式不同，与之匹配的职位不同。</p>
                            <p>马斯顿博士采用非常典型的人格特质因子来衡量人群的情绪反映，即Dominance－支配，Influence－影响，Steady－稳健，以及Compliance－服从。</p>
                            <p>行为特征分析基于DISC理论，展现了四个基本风格，预见其可能的工作表现。利用DISC行为分析方法了解个体情感、工作特征、行为风格、沟通方式、能力特征、人际关系、优劣势等等。</p>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top:100px">
                        <el-col :span="20" :offset="2" class="text-left">
                            <p>DISC性格测验是企业广泛应用的一种人格测验，用于测查、评估和帮助人们改善其行为方式、人际关系、工作绩效、团队合作、领导风格等。</p>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top:200px">
                        <el-col :span="20" :offset="2" style="background: #d6eafdc9;border-radius: 10px;padding:30px 50px">
                            <el-row>
                                <h1><i class="el-icon-warning"></i>&nbsp;&nbsp;查看报告提示</h1>
                            </el-row>
                            <el-row class="text-left">
                                <p>1、性格没有好与坏，测试的目的是反映最真实的自己，没有好坏优劣。</p>
                                <p>2、本报告是基于受测者对全部问题的回答所生成的评估结果，因此受测者的作答状态、自我认知和坦白程度等因素，均会影响其报告结果的真实性、准确性和有效性。</p>
                                <p>3、本报告的有效期为6至12个月，如果受测者的生活或工作发生重大变化，应考虑再次参与测评。</p>
                            </el-row>
                        </el-col>
                    </el-row>
                    
                    <el-row class="foot-row">
                        <div class="title-font">DISC性格测评</div>
                        <div class="title-line"></div>
                        <div class="title-user">{{username}}</div>
                        <div class="title-page">第1页</div>
                    </el-row>
                </div>

                <div class="page-div">
                    <img :src="titleImg" class="head-row">
                    <el-row>
                        <el-col :span="10" :offset="2">
                            <h1 class="text-left">一、结果概要</h1>
                        </el-col>
                    </el-row>
                    <el-main>
                        <el-row :gutter="20" style="margin-bottom:10px;">
                            <el-col :span="16" :offset="4">
                                <div id="myChart" :style="{width: '100%', height: '280px'}"></div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" style="background: #d6eafdc9;border-radius: 10px;padding:30px 50px">
                                <el-row>
                                    <h2>这种典型行为风格，<span style="font-size:26px;color:#3b8ad9">可被大致描述为是"{{backdata.disc_ML.des}}"的类型</span></h2>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:20px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 48px;text-align: left;padding-left:20px;color:#fff">总结</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{backdata.disc_ML.describ}}</p>
                                <p>【<span>行为特征</span>】{{backdata.disc_ML.action}}</p>
                                <p>【<span>交流沟通</span>】{{backdata.disc_ML.comm}}</p>
                                <p>【<span>能力特征</span>】{{backdata.disc_ML.ability}}</p>
                                <p>【<span>行为优势</span>】{{backdata.disc_ML.advantage}}</p>
                                <p>【<span>行为弱势</span>】{{backdata.disc_ML.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main>
                    <el-row class="foot-row">
                        <div class="title-font">DISC性格测评</div>
                        <div class="title-line"></div>
                        <div class="title-user">{{username}}</div>
                        <div class="title-page">第2页</div>
                    </el-row>
                </div>
                
                <div class="page-div">
                    <img :src="titleImg" class="head-row">
                    <el-row>
                        <el-col :span="10" :offset="2">
                            <h1 class="text-left">二、工作情境下的行为表现</h1>
                        </el-col>
                    </el-row>
                    <el-main>
                        <el-row :gutter="20" style="margin-bottom:10px;">
                            <el-col :span="16" :offset="4">
                                <div id="mChart" :style="{width: '100%', height: '280px'}"></div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" style="background: #d6eafdc9;border-radius: 10px;padding:30px 50px">
                                <el-row>
                                    <h2>{{backdata.disc_M.keyword}}</h2>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:20px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 48px;text-align: left;padding-left:20px;color:#fff">{{backdata.disc_M.title}} {{backdata.disc_M.des}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{backdata.disc_M.describ}}</p>
                                <p>【<span>情感</span>】{{backdata.disc_M.emotion}}</p>
                                <p>【<span>工作</span>】{{backdata.disc_M.work}}</p>
                                <p>【<span>人际</span>】{{backdata.disc_M.relation}}</p>
                                <p>【<span>优势</span>】{{backdata.disc_M.advantage}}</p>
                                <p>【<span>弱势</span>】{{backdata.disc_M.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main>
                    <el-row class="foot-row">
                        <div class="title-font">DISC性格测评</div>
                        <div class="title-line"></div>
                        <div class="title-user">{{username}}</div>
                        <div class="title-page">第3页</div>
                    </el-row>
                </div>
                <div class="page-div">
                    <img :src="titleImg" class="head-row">
                    <el-row>
                        <el-col :span="10" :offset="2">
                            <h1 class="text-left">三、压力情绪下的行为风格</h1>
                        </el-col>
                    </el-row>
                    <el-main>
                        <el-row :gutter="20" style="margin-bottom:10px;">
                            <el-col :span="16" :offset="4">
                                <div id="lChart" :style="{width: '100%', height: '280px'}"></div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" style="background: #d6eafdc9;border-radius: 10px;padding:30px 50px">
                                <el-row>
                                    <h2>{{backdata.disc_L.keyword}}</h2>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:20px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 48px;text-align: left;padding-left:20px;color:#fff">{{backdata.disc_L.title}} {{backdata.disc_L.des}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{backdata.disc_L.describ}}</p>
                                <p>【<span>情感</span>】{{backdata.disc_L.emotion}}</p>
                                <p>【<span>工作</span>】{{backdata.disc_L.work}}</p>
                                <p>【<span>人际</span>】{{backdata.disc_L.relation}}</p>
                                <p>【<span>优势</span>】{{backdata.disc_L.advantage}}</p>
                                <p>【<span>弱势</span>】{{backdata.disc_L.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main>
                    <el-row class="foot-row">
                        <div class="title-font">DISC性格测评</div>
                        <div class="title-line"></div>
                        <div class="title-user">{{username}}</div>
                        <div class="title-page">第4页</div>
                    </el-row>
                </div>
                <div class="page-div">
                    <img :src="titleImg" class="head-row">
                    <el-row style="margin-bottom:0">
                        <el-col :span="10" :offset="2">
                            <h1 class="text-left" style="margin-top:0;margin-bottom:0">四、结果参考</h1>
                        </el-col>
                    </el-row>
                    <el-main style="padding-top:0">
                        <el-row style="margin-bottom:0">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 48px;text-align: left;padding-left:20px;color:#fff">{{backdata.disc_data.D.title}} {{backdata.disc_data.D.des}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{backdata.disc_data.D.describ}}</p>
                                <p>【<span>情感</span>】{{backdata.disc_data.D.emotion}}</p>
                                <p>【<span>工作</span>】{{backdata.disc_data.D.work}}</p>
                                <p>【<span>人际</span>】{{backdata.disc_data.D.relation}}</p>
                                <p>【<span>优势</span>】{{backdata.disc_data.D.advantage}}</p>
                                <p>【<span>弱势</span>】{{backdata.disc_data.D.disadvantage}}</p>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom:0">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 48px;text-align: left;padding-left:20px;color:#fff">{{backdata.disc_data.I.title}} {{backdata.disc_data.I.des}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{backdata.disc_data.I.describ}}</p>
                                <p>【<span>情感</span>】{{backdata.disc_data.I.emotion}}</p>
                                <p>【<span>工作</span>】{{backdata.disc_data.I.work}}</p>
                                <p>【<span>人际</span>】{{backdata.disc_data.I.relation}}</p>
                                <p>【<span>优势</span>】{{backdata.disc_data.I.advantage}}</p>
                                <p>【<span>弱势</span>】{{backdata.disc_data.I.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main>
                    <el-row class="foot-row">
                        <div class="title-font">DISC性格测评</div>
                        <div class="title-line"></div>
                        <div class="title-user">{{username}}</div>
                        <div class="title-page">第5页</div>
                    </el-row>
                </div>
                <div class="page-div">
                    <img :src="titleImg" class="head-row">
                    <el-main>
                        <el-row style="margin-top:10px;margin-bottom:0">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 48px;text-align: left;padding-left:20px;color:#fff">{{backdata.disc_data.S.title}} {{backdata.disc_data.S.des}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{backdata.disc_data.S.describ}}</p>
                                <p>【<span>情感</span>】{{backdata.disc_data.S.emotion}}</p>
                                <p>【<span>工作</span>】{{backdata.disc_data.S.work}}</p>
                                <p>【<span>人际</span>】{{backdata.disc_data.S.relation}}</p>
                                <p>【<span>优势</span>】{{backdata.disc_data.S.advantage}}</p>
                                <p>【<span>弱势</span>】{{backdata.disc_data.S.disadvantage}}</p>
                            </el-col>
                        </el-row>
                        <el-row style="margin-bottom:0">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 48px;text-align: left;padding-left:20px;color:#fff">{{backdata.disc_data.C.title}} {{backdata.disc_data.C.des}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{backdata.disc_data.C.describ}}</p>
                                <p>【<span>情感</span>】{{backdata.disc_data.C.emotion}}</p>
                                <p>【<span>工作</span>】{{backdata.disc_data.C.work}}</p>
                                <p>【<span>人际</span>】{{backdata.disc_data.C.relation}}</p>
                                <p>【<span>优势</span>】{{backdata.disc_data.C.advantage}}</p>
                                <p>【<span>弱势</span>】{{backdata.disc_data.C.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main>
                    <el-row class="foot-row">
                        <div class="title-font">DISC性格测评</div>
                        <div class="title-line"></div>
                        <div class="title-user">{{username}}</div>
                        <div class="title-page">第6页</div>
                    </el-row>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    export default {
        name: 'baseform',
        data: function(){
            return {
                total: 24,
                xuhao: 1,
                result:[],
                options:[],
                checkbox:[],
                percentage: 0,
                question:"",
                btnStyle: [],

                user_id:"",
                username:"",
                phone:"",

                backdata : {
                    disc_ML:{},
                    disc_L:{},
                    disc_M:{},
                    disc_data:{
                        D:{},
                        I:{},
                        S:{},
                        C:{}
                    }
                },


                htmlTitle: '',
                titleImg: require("../../assets/title.png"),
                titleImg2: require("../../assets/title.jpg"),
                qrcodeImg: require("../../assets/qrcode.jpg"),
                prefaceImg: require("../../assets/preface.jpg"),
                // bgImg: require("../../assets/bgimg.jpg"),
                imgStyle:{
                    backgroundImage: `url(${require("../../assets/bgimg.jpg")})`, backgroundRepeat: 'no-repeat', width:'100%', height: '73px', 'background-size': '100% auto'
                }
            }
        },
        mounted() {
            let user_id = this.$route.query.id;
            let username = this.$route.query.username;
            let phone = this.$route.query.phone;
            console.log(user_id)
            if(!username || !phone){
                this.$router.push({name:'login',params:{msg:"请填写个人信息！"}});
            }else{
                this.user_id = user_id;
                this.username = username;
                this.phone = phone;
                this.htmlTitle = `${username}_${phone}.pdf`;
                //查询是否已经答题
                this.$axios.post('/api/queryDiscStatus', {user_id, username, phone}).then( res => {
                    if(res.data.msg == "faild"){
                        let create_time = res.data.create_time;
                        this.$confirm(`您已经于${create_time}进行过相关测评，是否需要重新答题并生成报告？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            center: true,
                            closeOnPressEscape:false,
                            closeOnClickModal:false,
                            showClose:false,
                        }).then(() => { //确定
                           this.getDiscOptionData();
                        }).catch(() => {    //取消

                        });
                        // this.getDiscResultData()
                    }else if(res.data.msg == "success"){
                        this.getDiscOptionData();
                    }
                });
            }
            console.log(this.$route.query.username)
            console.log(this.$route.query.phone)
        },
        methods: {
            //点击选项
            checkedData(i, id, m_type, l_type){
                if(this.checkbox.length == 2){
                    this.checkbox.splice(0,2);
                    this.result[this.xuhao-1] = {};
                }
                if(this.checkbox.indexOf(i) < 0){
                    this.checkbox.push(i);
                }else if(this.checkbox.indexOf(i) == 0){
                    this.checkbox = [-1,-1];
                    this.result[this.xuhao-1] = {}; 
                    this.reloadBtnStyle();
                }
                if(this.checkbox.length == 1){  //最符合
                    this.result[this.xuhao-1] = {xuhao: 1, m_id: id, m_type: m_type,l_id:'',l_type:''};
                    this.reloadBtnStyle();
                }else if(this.checkbox.length == 2 && this.checkbox[0] != this.checkbox[1]){  //最不符合
                    this.btnStyle[i]["el-button--primary"] = false;
                    this.btnStyle[i]["el-button--danger"] = true;

                    this.result[this.xuhao-1].l_id = id;
                    this.result[this.xuhao-1].l_type = l_type;

                    const that = this;
                    setTimeout(function(){
                        if(that.checkbox.length == 2){
                            that.percentage = that.result.length*100/that.total;
                            if(that.result.length == that.total && that.xuhao == 24){   //完成答题
                                that.onSubmit();    //确认提交
                            }else{
                                that.xuhao = that.xuhao == 24 ? that.xuhao : that.xuhao+1;
                                that.getDiscOptionData();
                            }
                        }
                    },100);
                }
            },
            //获取选项信息
            getDiscOptionData(){
                this.$axios.post('/api/getDiscOptionData', {xuhao: this.xuhao}).then( res => {
                    this.options = res.data;
                    this.checkbox = [];
                    this.reloadBtnStyle();
                });
            },
            percentageFormat() {    //百分比
                return `${this.result.length}/${this.total}`;
            },
            reloadBtnStyle(){       //重新加载选项样式
                if(this.xuhao <= this.result.length){   //已选样式
                    var index1 = (this.result[this.xuhao-1]["m_id"]-1)%4;
                    var index2 = (this.result[this.xuhao-1]["l_id"]-1)%4;
                    for(var i=0;i<4;i++){
                        this.btnStyle[i]["el-button--primary"] = (index1 == i ? true : false);  //最符合
                        this.btnStyle[i]["el-button--danger"] = (index2 == i ? true : false);   //最不符合
                    }
                }else{  //未选样式
                    this.btnStyle = [
                        {'el-button--danger':false,'el-button--primary':false},
                        {'el-button--danger':false,'el-button--primary':false},
                        {'el-button--danger':false,'el-button--primary':false},
                        {'el-button--danger':false,'el-button--primary':false}
                    ];
                }
            },
            prevOption(){   //上一题
                this.xuhao = this.xuhao-1;
                this.getDiscOptionData();
            },
            nextOption(){   //下一题
                this.xuhao = this.xuhao+1;
                this.getDiscOptionData();
            },
            onSubmit() {    //确认提交
                this.$confirm('确认提交测评结果?', '提示', {
                    center: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnPressEscape:false,
                    closeOnClickModal:false,
                }).then(() => {
                    this.submitDiscResult();
                }).catch(() => {
                           
                });
                // this.$message.success('提交成功！');
            },
            submitDiscResult(){ //完成答题--保存结果
                var md = 0; var mi = 0; var ms = 0; var mc = 0; var mx = 0; //最符合
                var ld = 0; var li = 0; var ls = 0; var lc = 0; var lx = 0; //最不符合
                var data = this.result;
                for(var k of data){
                    //最符合
                    if(k["m_type"] == "D"){
                        md++;
                    }else if(k["m_type"] == "I"){
                        mi++
                    }else if(k["m_type"] == "S"){
                        ms++;
                    }else if(k["m_type"] == "C"){
                        mc++;
                    }else if(k["m_type"] == "X"){
                        mx++;
                    }
                    //最不符合
                    if(k["m_type"] == "D"){
                        ld++;
                    }else if(k["l_type"] == "I"){
                        li++
                    }else if(k["l_type"] == "S"){
                        ls++;
                    }else if(k["l_type"] == "C"){
                        lc++;
                    }else if(k["l_type"] == "X"){
                        lx++;
                    }
                }

                var mld = md-ld;
                var mli = mi-li;
                var mls = ms-ls;
                var mlc = mc-lc;
                var mlx = mx-lx;

                console.log("mld=====>>>>" + mld)
                console.log("mli=====>>>>" + mli)
                console.log("mls=====>>>>" + mls)
                console.log("mlc=====>>>>" + mlc)
                
                
                var entry = {
                    result: this.result,
                    md,mi,ms,mc,mx,ld,li,ls,lc,lx,mld,mli,mls,mlc,mlx,
                    username: this.username,
                    user_id: this.user_id,
                    phone: this.phone
                }
                console.log(entry)
                this.$axios.post('/api/saveDiscResult', entry).then( res => {
                    if(res.data == "success"){
                        this.getDiscResultData();
                    }else{
                        this.showMsgBox(res.data,"错误提示");
                    }
                });
            },
            //错误信息提示
            showMsgBox(msg,title){
                this.$alert(msg, title, {
                    confirmButtonText: '确定',
                    type: 'warning',
                    center: true,
                    'close-on-press-escape':false,
                    'close-on-click-modal':false
                }).then(() => {
                    this.xuhao = 1;
                    this.result = [];
                    this.percentage = 0;
                    this.getDiscOptionData();
                });
            },
            getDiscResultData(){
                //loading遮罩层
                const loading = this.$loading({
                    lock: true,
                    text: '正在保存测评结果，请不要退出当前页面！',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let params = {
                    username: this.username,
                    phone: this.phone,
                    user_id: this.user_id
                }
                this.$axios.post('/api/getDiscResultData', params).then( res => {
                    this.backdata = res.data;
                    
                    //通过id获取
                    var part =document.getElementById("pdfDom");
                    //修改display
                    part.style.display="block";
    
                    this.loadMChart();
                    this.loadLChart();
                    this.drawLine(); 
                    const that = this;
                    setTimeout(function(){
                        window.scrollTo(0,0);
                        that.getPdf();
                        //通过id获取
                        var part =document.getElementById("pdfDom");
                        //修改display
                        part.style.display="none";
                        setTimeout(function(){
                            loading.close();
                            that.$confirm("感谢答题！请退出本次测评", "", {
                                center: true,
                                closeOnPressEscape:false,
                                closeOnClickModal:false,
                                showClose:false,
                                showCancelButton:false,
                                showConfirmButton:false,
                            });
                        },200);
                    },1100);
                });
            },
            drawLine(){
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById('myChart'))
                let option = {
                    tooltip: {
                        formatter: function(){
                            return ''
                        }
                    },
                    grid: {
                        top:10,
                        bottom:10,
                        left:10,
                        right:10,
                        show:'true',
                        borderWidth:'2',
                        borderColor:"#9a9898cf",
                    },
                    xAxis: {
                        type: 'category',
                        data: ['D', 'I', 'S', 'C'],
                        position: 'top',
                        nameTextStyle: {
                            borderColor: "#9a9898cf",
                            borderWidth: 2
                        },
                        axisTick: {
                            show: true,
                            length: '0',
                            lineStyle: {
                                width:2
                            }
                        },
                        axisLabel: {
                            show: false
                        }
                    },
                    yAxis: {
                        show:false,
                        type: 'value',
                        max: 120,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    series: [
                        {
                            name: '自我形象',
                            type: 'line',
                            data: this.backdata.disc_ML.data,
                            symbol: 'circle', //折线点设置为实心点
                            symbolSize: 10, //折线点的大小
                            smooth: true,
                            markArea: {
                                silent: true,
                                data: [
                                    [
                                        {
                                            yAxis: 44,
                                            itemStyle: {
                                                color: '#ffdee061'
                                            },
                                        }, {
                                            yAxis: 57
                                        }
                                    ]
                                ]
                            },
                            markLine : {
                                symbol:"none",
                                itemStyle:{
                                    normal:{
                                        color:'#FA8565',
                                    }
                                },
                                data : [
                                    {
                                        silent:false, //鼠标悬停事件
                                        lineStyle:{ //警戒线的样式
                                            type:"solid", //样式  ‘solid’和‘dotted‘
                                            color:"#c82d31",
                                            width: 2   //宽度
                                        },
                                        yAxis: 51,
                                        label: {
                                            normal: {
                                                formatter: ''
                                            }
                                        }
                                    },
                                    {
                                        silent:false, //鼠标悬停事件
                                        lineStyle:{ //警戒线的样式
                                            type:"solid", //样式  ‘solid’和‘dotted‘
                                            color:"#9a9898cf",
                                            width: 2   //宽度
                                        },
                                        yAxis: 100,
                                        label: {
                                            normal: {
                                                formatter: ''
                                            }
                                        }
                                    }
                                ]
                            },
                            markPoint: {
                                label: {
                                    color: "#71a5d6",
                                    fontWeight: "bold",
                                    fontSize: 14
                                },
                                symbolSize:1,
                                data: [
                                    {value: 'D', xAxis: 'D', yAxis: 110},
                                    {value: 'I', xAxis: 'I', yAxis: 110},
                                    {value: 'S', xAxis: 'S', yAxis: 110},
                                    {value: 'C', xAxis: 'C', yAxis: 110},
                                ]

                            }
                        },{
                            data: [0,0,0,0],
                            type: 'bar',
                            barWidth: 50,
                            showBackground: true,
                            backgroundStyle: {
                                borderColor: "#9a9898cf",
                                borderWidth: 2,
                                color: 'rgba(180, 180, 180, 0.2)'
                            }
                        }
                    ],
                    visualMap: [{
                        show: false,
                        type: 'continuous',
                        seriesIndex: 0,
                        min: 0,
                        max: 100,
                        pieces: [
                            { gte: 0, lt: 51, color: '#b8ddf0' },
                            // { gte: 40, lt: 60, color: '#e0bdb8' },
                            { gte: 51, lt: 100, color: '#EB190A' },
                        ]
                    }]
                };
                // 绘制图表
                myChart.setOption(option);
            },
            loadMChart(){
                let mChart = this.$echarts.init(document.getElementById('mChart'))
                let option = {
                    tooltip: {
                        formatter: function(){
                            return ''
                        }
                    },
                    grid: {
                        top:10,
                        bottom:10,
                        left:10,
                        right:10,
                        show:'true',
                        borderWidth:'2',
                        borderColor:"#9a9898cf",
                    },
                    xAxis: {
                        type: 'category',
                        data: ['D', 'I', 'S', 'C'],
                        position: 'top',
                        nameTextStyle: {
                            borderColor: "#9a9898cf",
                            borderWidth: 2
                        },
                        axisTick: {
                            show: true,
                            length: '0',
                            lineStyle: {
                                width:2
                            }
                        },
                        axisLabel: {
                            show: false
                        }
                    },
                    yAxis: {
                        show:false,
                        type: 'value',
                        max: 120,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    series: [
                        {
                            name: '工作情境下的行为表现',
                            type: 'line',
                            data: this.backdata.disc_M.data,
                            symbol: 'circle', //折线点设置为实心点
                            symbolSize: 10, //折线点的大小
                            smooth: true,
                            markLine : {
                                symbol:"none",
                                itemStyle:{
                                    normal:{
                                        color:'#FA8565',
                                    }
                                },
                                data : [
                                    {
                                        silent:false, //鼠标悬停事件
                                        lineStyle:{ //警戒线的样式
                                            type:"solid", //样式  ‘solid’和‘dotted‘
                                            color:"#c82d31",
                                            width: 2   //宽度
                                        },
                                        yAxis: 51,
                                        label: {
                                            normal: {
                                                formatter: ''
                                            }
                                        }
                                    },
                                    {
                                        silent:false, //鼠标悬停事件
                                        lineStyle:{ //警戒线的样式
                                            type:"solid", //样式  ‘solid’和‘dotted‘
                                            color:"#9a9898cf",
                                            width: 2   //宽度
                                        },
                                        yAxis: 100,
                                        label: {
                                            normal: {
                                                formatter: ''
                                            }
                                        }
                                    }
                                ]
                            },
                            markPoint: {
                                label: {
                                    color: "#71a5d6",
                                    fontWeight: "bold",
                                    fontSize: 14
                                },
                                symbolSize:1,
                                data: [
                                    {value: 'D', xAxis: 'D', yAxis: 110},
                                    {value: 'I', xAxis: 'I', yAxis: 110},
                                    {value: 'S', xAxis: 'S', yAxis: 110},
                                    {value: 'C', xAxis: 'C', yAxis: 110},
                                ]

                            }
                        },
                        {
                            data: [0,0,0,0],
                            type: 'bar',
                            barWidth: 50,
                            showBackground: true,
                            backgroundStyle: {
                                borderColor: "#9a9898cf",
                                borderWidth: 2,
                                color: 'rgba(180, 180, 180, 0.2)'
                            }
                        }
                    ],
                    
                };
                // 绘制图表
                mChart.setOption(option);
            },
            loadLChart(){
                let lChart = this.$echarts.init(document.getElementById('lChart'))
                let option = {
                    tooltip: {
                        formatter: function(){
                            return ''
                        }
                    },
                    grid: {
                        top:10,
                        bottom:10,
                        left:10,
                        right:10,
                        show:'true',
                        borderWidth:'2',
                        borderColor:"#9a9898cf",
                    },
                    xAxis: {
                        type: 'category',
                        data: ['D', 'I', 'S', 'C'],
                        position: 'top',
                        nameTextStyle: {
                            borderColor: "#9a9898cf",
                            borderWidth: 2
                        },
                        axisTick: {
                            show: true,
                            length: '0',
                            lineStyle: {
                                width:2
                            }
                        },
                        axisLabel: {
                            show: false
                        }
                    },
                    yAxis: {
                        show:false,
                        type: 'value',
                        max: 120,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    series: [
                        {
                            name: '压力情境下的行为风格',
                            type: 'line',
                            data: this.backdata.disc_L.data,
                            symbol: 'circle', //折线点设置为实心点
                            symbolSize: 10, //折线点的大小
                            smooth: true,
                            markLine : {
                                symbol:"none",
                                itemStyle:{
                                    normal:{
                                        color:'#FA8565',
                                    }
                                },
                                data : [
                                    {
                                        silent:false, //鼠标悬停事件
                                        lineStyle:{ //警戒线的样式
                                            type:"solid", //样式  ‘solid’和‘dotted‘
                                            color:"#c82d31",
                                            width: 2   //宽度
                                        },
                                        yAxis: 51,
                                        label: {
                                            normal: {
                                                formatter: ''
                                            }
                                        }
                                    },
                                    {
                                        silent:false, //鼠标悬停事件
                                        lineStyle:{ //警戒线的样式
                                            type:"solid", //样式  ‘solid’和‘dotted‘
                                            color:"#9a9898cf",
                                            width: 2   //宽度
                                        },
                                        yAxis: 100,
                                        label: {
                                            normal: {
                                                formatter: ''
                                            }
                                        }
                                    }
                                ]
                            },
                            markPoint: {
                                label: {
                                    color: "#71a5d6",
                                    fontWeight: "bold",
                                    fontSize: 14
                                },
                                symbolSize:1,
                                data: [
                                    {value: 'D', xAxis: 'D', yAxis: 110},
                                    {value: 'I', xAxis: 'I', yAxis: 110},
                                    {value: 'S', xAxis: 'S', yAxis: 110},
                                    {value: 'C', xAxis: 'C', yAxis: 110},
                                ]
                            }
                        },
                        {
                            data: [0,0,0,0],
                            type: 'bar',
                            barWidth: 50,
                            showBackground: true,
                            backgroundStyle: {
                                borderColor: "#9a9898cf",
                                borderWidth: 2,
                                color: 'rgba(180, 180, 180, 0.2)'
                            }
                        }
                    ],
                };
                // 绘制图表
                lChart.setOption(option);
            }

        }
    }
</script>
<style>
    .question {
        width:100%;
        text-align: center;
    }
    .question button{
        width:70%;
        border-radius: 4px;
        padding:20px 25px;
        text-align: left;
        line-height: 18px;
        white-space: break-spaces;
        box-shadow: 5px 4px 5px #888 !important;
    }
    .el-button.is-plain:focus, .el-button.is-plain:hover {
        background: #FFF;
        border-color: #DCDFE6;
        color: #606266;
    }
    .el-dialog .el-button--primary span{
        color: #fff;
    }
    .el-button--primary.is-plain:active {
        color: #409EFF;
        background: #ecf5ff;
        border-color: #b3d8ff;
    }
    .el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover {
        color: #409EFF;
        background: #ecf5ff;
        border-color: #b3d8ff;
    }
    .el-button--danger.is-plain:active {
        color: #F56C6C;
        background: #fef0f0;
        border-color: #fbc4c4;
    }
    .el-button--danger.is-plain:focus, .el-button--danger.is-plain:hover {
        color: #F56C6C;
        background: #fef0f0;
        border-color: #fbc4c4;
    }

    #question .el-row {
        margin-bottom: 20px;
    }
    .el-col {
        border-radius: 4px;
    }
    .el-badge__content.is-fixed{
        right:19% !important;
    }


#pdfDom{
    font-family: "SimSun" !important;
}
#pdfDom span{
    color: #707478;
}
.text-right {
    text-align: right !important;
}
.text-left {
    font-size:22px;
    text-align: left !important;
}


.el-timeline p{
    text-align: left;
    margin:3px 0;
    font-size:22px;
}
.el-timeline div{
    font-size:22px;
}
.el-timeline span{
    font-weight: blod;
}
.card-title{
    text-align: left;
    padding: 10px 10px 5px;
    /* margin-bottom:5px; */
}
.el-card{
    margin-top:5px;
}
.el-main{
    /* width: 1100px; */
    margin: 0 auto;
    padding-top:2px;
    padding-bottom:2px;
}
.el-timeline {
    text-align:left;
    font-size:22px !important;
}
.page-div{
    /* font-size:18px; */
    width:100%;
    height:1584px;
    /* padding-top:100px; */
    padding-top:70px;
    padding-bottom:50px;
    border:0;
    position: relative;
    /* border:1px solid black; */
}
.page-div h1{
    font-size: 30px;
}
.page-div h2{
    font-size: 26px;
}
.page-div span{
    font-size:22px;
}
.page-div .el-card__body {
    font-size:22px !important;
    padding: 5px 10px !important;
}
.el-timeline-item__timestamp{
    font-size: 22px !important;
    text-align: left !important;
}
/* 页眉 */
.head-row{
    width:150px;
    position:absolute !important;
    right:10px;
    top:10px;
}
/* 页脚 */
.foot-row{
    position:absolute !important;
    bottom:40px;
}
.title-font{
    float:left;
    margin-left:100px;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Microsoft YaHei';
}
.title-line{
    float:left;
    margin-left:20px;
    margin-top:10px;
    height:5px;
    width:750px;
    background-color:#71a5d5;
}
.title-user{
    float:left;
    margin-left:20px;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Microsoft YaHei';
}
.title-page{
    float:left;
    margin-left:20px;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Microsoft YaHei';
    color:#a0a4a9;
}
</style>